<script setup lang="ts">
import { CommonTitle } from '~/components/common'
import { InputField, InputToggle } from '@caks/uikit/input'
import {getProfileData, patchProfile} from '@caks/shared/api/user.route'
import {ButtonMain} from "@caks/uikit/button";
import { vMaska } from 'maska'

const name = ref('')
const phone = ref('')
const email = ref('')
const birthday = ref('')
const notificationsActive = ref(true)

const baseData = {
  name: '',
  phone: '',
  email: '',
  birthday: '',
  notificationsActive: false
}

const startSend = ref<boolean>(false)
//const sendError = ref(false)
const sendResultInfo = ref('')

onMounted(async () => {
  const { data } = await getProfileData()
  name.value = data.name
  phone.value = data.phone
  email.value = data.email
  notificationsActive.value = data.push_enabled

  // const date = new Date()
  // date.setMonth(data.bday.month)
  // date.setUTCDate(data.bday.day)
  // console.log('Date', date)
  // birthday.value = birthday.value ? date.toLocaleDateString() : new Date().toISOString().split('T')[0]

  const year = new Date().getFullYear(); // Используем текущий год
  birthday.value = new Date(data.bday.year || year, data.bday.month - 1, data.bday.day + 1).toISOString().slice(0, 10);

  baseData.name = data.name
  baseData.phone = data.phone
  baseData.email = data.email
  baseData.birthday = birthday.value
  baseData.notificationsActive = data.push_enabled
})

const changeData = async () => {
  const resData = {};

  if(baseData.name !== name.value) resData["name"] = name.value
  if(baseData.email !== email.value) resData["email"] = email.value
  if(baseData.phone.replace(/[+-]/gi, '') !== phone.value.replace(/[+-]/gi, '')) resData["phone"] = phone.value
  if(baseData.notificationsActive !== notificationsActive.value) resData["push_enabled"] = notificationsActive.value
  if(baseData.birthday !== birthday.value) {
    const selectedDate = new Date(birthday.value)
    const day = selectedDate.getUTCDate()
    const month = selectedDate.getMonth() + 1
    const year = selectedDate.getFullYear()

    resData["bday"] = {
      day,
      month,
      year,
    }
  }

  sendResultInfo.value = ''

  startSend.value = true;
  const {code, data} = await patchProfile({
    ...resData
  })

  if(code !== 0) {
    sendResultInfo.value = '<p class="error" style="color: #ff1616; font-size: 14px; margin: 10px 0; font-family: \'Inter\'">Ошибка!</p>'
  } else {
    name.value = data.name
    phone.value = data.phone
    email.value = data.email
    notificationsActive.value = data.push_enabled

    const year = new Date().getFullYear();
    birthday.value = new Date(data.bday.year || year, data.bday.month - 1, data.bday.day + 1).toISOString().slice(0, 10);
    baseData.name = data.name
    baseData.phone = data.phone
    baseData.email = data.email
    baseData.birthday = birthday.value
    baseData.notificationsActive = data.push_enabled

    sendResultInfo.value = '<p class="success" style="color: #009e50; font-size: 14px; margin: 10px 0; font-family: \'Inter\'">Успех</p>'
  }

  startSend.value = false;
}

const btnNotActive = computed(() => {
  if(startSend.value) return false

  if(baseData.name !== name.value || baseData.email !== email.value || baseData.birthday !== birthday.value || baseData.notificationsActive !== notificationsActive.value) {
    console.log('here');
    return false
  }

  return true
})

</script>

<template>
  <div class="personal">
    <common-title title="Личные данные" />
    <input-field v-model="name" placeholder="Имя" label="Имя" />
    <input-field v-model="phone" :disabled="true" data-maska="+7-###-###-##-##" v-maska placeholder="Номер телефона" label="Телефон" />
<!--    <input-field v-model="birthday" :type="'date'" placeholder="Дата рождения" label="Дата рождения" />-->
    <div class="personal__birthday">
      <span>Дата рождения</span>
      <VueDatePicker :locale="'ru'"  :enable-time-picker="false" format="dd/MM/yyyy" :max-date="new Date().setYear('2025')" v-model="birthday" select-text="Выбрать" cancel-text="Отменить"></VueDatePicker>
    </div>
    <input-field v-model="email" placeholder="Email" label="Email" />
    <div class="personal__notifications notifications">
      <div class="notifications__text">
        <h4>Уведомления</h4>
        <p>Персональные предложения и акции</p>
        <p>Пуш-уведомления, почта, смс</p>
      </div>
      <input-toggle v-model="notificationsActive" />
    </div>
<!--    <p class="personal__text_error" v-if="sendError">-->
<!--      Ошибка сохранения, проверьте корректность данных-->
<!--    </p>-->
    <div v-html="sendResultInfo"></div>
    <button-main @click="changeData" :disabled="btnNotActive" :class="startSend ? 'loading' : ''">
      Сохранить
    </button-main>
  </div>
</template>

<style scoped lang="scss">
.personal {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 416px;

  &__birthday {
    span {
      @include h5-2;
      color: $sub-text;
      display: block;
      margin-bottom: 8px;
    }
  }

  h3:first-child {
    margin-bottom: 8px;
  }

  &__text_error {
    @include h5-2;
    color: $primary-red;
  }

  .notifications {
    display: flex;
    align-items: center;
    gap: 8px;

    &__text {
      display: flex;
      flex-direction: column;
      gap: 8px;

      :nth-child(1) {
        color: $primary-text;
        @include h3-5;
      }

      :nth-child(2) {
        color: $sub-text;
        @include h5-2;
      }

      :nth-child(3) {
        color: $sub-text;
        @include h6-3;
      }
    }
  }
}
</style>
